import { render, staticRenderFns } from "./FormGalerie.vue?vue&type=template&id=7895a433&"
import script from "./FormGalerie.vue?vue&type=script&lang=js&"
export * from "./FormGalerie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports